// src/components/Templates/TemplateCard.jsx
/**
 * Card individual para exibição de um template de WhatsApp.
 * Mostra nome, categoria, status e preview do corpo da mensagem.
 */

import React from "react";
import "./Templates.css";

const statusColors = {
  APPROVED: "template-status-approved",
  PENDING: "template-status-pending",
  REJECTED: "template-status-rejected",
};

const statusLabels = {
  APPROVED: "Aprovado",
  PENDING: "Pendente",
  REJECTED: "Rejeitado",
};

const categoryLabels = {
  UTILITY: "Utilidade",
  MARKETING: "Marketing",
  AUTHENTICATION: "Autenticação",
};

const TemplateCard = ({
  template,
  isSelected = false,
  onClick,
  showFullPreview = false,
}) => {
  if (!template) return null;

  const bodyText = template.body_text || template.bodyText || "";
  const truncatedBody = bodyText.length > 100 && !showFullPreview
    ? `${bodyText.substring(0, 100)}...`
    : bodyText;

  return (
    <div
      className={`template-card ${isSelected ? "template-card-selected" : ""}`}
      onClick={() => onClick && onClick(template)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick && onClick(template)}
    >
      <div className="template-card-header">
        <div className="template-card-name">{template.name}</div>
        <span
          className={`template-status-badge ${statusColors[template.status] || ""}`}
        >
          {statusLabels[template.status] || template.status}
        </span>
      </div>

      <div className="template-card-meta">
        <span className="template-meta-item">
          {categoryLabels[template.category] || template.category}
        </span>
        <span className="template-meta-separator">|</span>
        <span className="template-meta-item">{template.language}</span>
      </div>

      {truncatedBody && (
        <div className="template-card-body">
          <span className="template-body-preview">"{truncatedBody}"</span>
        </div>
      )}

      {template.variables && template.variables.length > 0 && (
        <div className="template-card-variables">
          <span className="template-variables-label">Variáveis:</span>
          {template.variables.map((v, idx) => (
            <span key={idx} className="template-variable-tag">
              {`{{${v.key || v}}}`}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateCard;
